import React from "react";
import styles from "./SpeechToTextKeyFeatures.module.css";
import {
    Radio,
    Upload,
    Globe,
    Target,
    Pencil,
    Download
} from "lucide-react";

const features = [
    {
        icon: <Radio size={22} />,
        title: "Real-Time Transcription",
        desc: "See text appear as you speak. No delays.",
        color: "blue",
    },
    {
        icon: <Upload size={22} />,
        title: "Audio & Video Upload",
        desc: "MP3, WAV, MP4 — upload and transcribe in seconds.",
        color: "purple",
    },
    {
        icon: <Globe size={22} />,
        title: "Multi-Language Support",
        desc: "Transcribe across multiple languages and accents.",
        color: "green",
    },
    {
        icon: <Target size={22} />,
        title: "High Accuracy AI",
        desc: "Cleaner output. Fewer edits. Less frustration.",
        color: "red",
    },
    {
        icon: <Pencil size={22} />,
        title: "Editable Output",
        desc: "Fix, format, and export your text instantly.",
        color: "orange",
    },
    {
        icon: <Download size={22} />,
        title: "Export Anywhere",
        desc: "Download as TXT, DOCX, or copy with one click.",
        color: "indigo",
    },
];

const SpeechToTextKeyFeatures = () => {
    return (
        <section className={styles.featuresSection}>
            <h2 className={styles.heading}>KEY FEATURES</h2>

            <div className={styles.grid}>
                {features.map((item, index) => (
                    <div
                        key={index}
                        className={`${styles.card} ${styles[item.color]}`}
                        style={{ animationDelay: `${index * 0.1}s` }}
                    >
                        <div className={styles.iconBox}>{item.icon}</div>
                        <h3>{item.title}</h3>
                        <p>{item.desc}</p>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default SpeechToTextKeyFeatures;